/**
 * The docked record control shared by Voice, Conversation and Subtitles.
 *
 * One component so the microphone lives in the same place on every tab:
 * centered, docked at the bottom of the reading column just above the
 * footer, with everything else stacked above it. On phones it pins to the
 * viewport bottom so the thumb never chases it.
 */

import { Button } from "./ui";
import { LevelMeter, MicButton } from "./MicButton";

interface Props {
  live: boolean;
  busy: boolean;
  level: number;
  onToggle: () => void;
  toggleLabel: string;
  disabled?: boolean;
  onClear?: () => void;
  clearDisabled?: boolean;
  clearLabel?: string;
}

export function MicDock(props: Props) {
  return (
    <div className="micbar">
      <MicButton
        live={props.live}
        busy={props.busy}
        level={props.level}
        onClick={props.onToggle}
        label={props.toggleLabel}
        disabled={props.disabled}
      />
      <div className="row" style={{ gap: "var(--space-s)" }}>
        <LevelMeter level={props.level} />
        {props.onClear ? (
          <Button size="sm" onClick={props.onClear} disabled={props.clearDisabled} title={props.clearLabel ?? "Clear"} aria-label={props.clearLabel ?? "Clear"}>
            Clear
          </Button>
        ) : null}
      </div>
    </div>
  );
}
